import { ITypeCurveParameter } from '../../interfaces/itype-curve-parameter';
import { Case } from '../case';
import { ForecastDeclineCurveType } from '../forecast-decline-curve-type';
import { ForecastDeclineType } from '../forecast-decline-type';
import { ForecastDurationOuomType } from '../forecast-duration-ouom-type';
import { ForecastParemeterProductType } from '../forecast-paremeter-product-type';
import { ForecastRatioCurveType } from '../forecast-ratio-curve-type';
import { ForecastRatioFluidType } from '../forecast-ratio-fluid-type';
import { ForecastRatioVolumeOuomType } from '../forecast-ratio-volume-ouom-type';
import { ForecastSegmentType } from '../forecast-segment-type';
import { TypeCurve } from '../type-curve';

export class TypeCurveParameterBase {
  TypeCurveParameterId: number;
  CaseId: number;
  StartDate: number | null;
  EndDate: number | null;
  ForecastProductTypeId: number;
  ForecastSegmentTypeId: number;
  ForecastDeclineCurveTypeId: number;
  ForecastDeclineTypeId: number;
  ForecastDurationOuomTypeId: number;
  EffectiveDate: Date | null;
  Duration: number | null;
  InitialRate: number | null;
  InitialDecline: number | null;
  NFactor: number | null;
  FinalDecline: number | null;
  FinalRate: number | null;
  MinimumDecline: number | null;
  ForecastRatioCurveTypeId: number;
  ForecastRatioFluidTypeId: number;
  RatioInitialRate: number | null;
  RatioFinalRate: number | null;
  ForecastRatioVolumeOuomTypeId: number | null;
  Remark: string | null;
  UpdatedBy: number;
  Created: Date;
  Updated: Date;
  CreatedBy: number;
  SegmentNumber: number;
  SegmentId: string;
  TypeCurveId: number | null;
  IsActive: boolean;

  Case?: Case;
  ForecastDeclineCurveType?: ForecastDeclineCurveType;
  ForecastDeclineType?: ForecastDeclineType;
  ForecastDurationOuomType?: ForecastDurationOuomType;
  ForecastRatioCurveType?: ForecastRatioCurveType;
  ForecastRatioFluidType?: ForecastRatioFluidType;
  ForecastRatioVolumeOuomType?: ForecastRatioVolumeOuomType;
  ForecastSegmentType?: ForecastSegmentType;
  TypeCurve?: TypeCurve;
  ForecastParemeterProductType?: ForecastParemeterProductType;

  constructor(item?: ITypeCurveParameter) {
    if (item) {

      this.TypeCurveParameterId = item.TypeCurveParameterId;
      this.CaseId = item.CaseId;
      this.StartDate = item.StartDate;
      this.EndDate = item.EndDate;
      this.ForecastProductTypeId = item.ForecastProductTypeId;
      this.ForecastSegmentTypeId = item.ForecastSegmentTypeId;
      this.ForecastDeclineCurveTypeId = item.ForecastDeclineCurveTypeId;
      this.ForecastDeclineTypeId = item.ForecastDeclineTypeId;
      this.ForecastDurationOuomTypeId = item.ForecastDurationOuomTypeId;
      this.EffectiveDate = item.EffectiveDate ? new Date(item.EffectiveDate) : null;
      this.Duration = item.Duration;
      this.InitialRate = item.InitialRate;
      this.InitialDecline = item.InitialDecline;
      this.NFactor = item.NFactor;
      this.FinalDecline = item.FinalDecline;
      this.FinalRate = item.FinalRate;
      this.MinimumDecline = item.MinimumDecline;
      this.ForecastRatioCurveTypeId = item.ForecastRatioCurveTypeId;
      this.ForecastRatioFluidTypeId = item.ForecastRatioFluidTypeId;
      this.RatioInitialRate = item.RatioInitialRate;
      this.RatioFinalRate = item.RatioFinalRate;
      this.ForecastRatioVolumeOuomTypeId = item.ForecastRatioVolumeOuomTypeId;
      this.Remark = item.Remark;
      this.UpdatedBy = item.UpdatedBy;
      this.Created = item.Created ? new Date(item.Created) : null;
      this.Updated = item.Updated ? new Date(item.Updated) : null;
      this.CreatedBy = item.CreatedBy;
      this.SegmentNumber = item.SegmentNumber;
      this.SegmentId = item.SegmentId;
      this.TypeCurveId = item.TypeCurveId;
      this.IsActive = item.IsActive;

      this.Case = new Case(item.Case);
      this.ForecastDeclineCurveType = new ForecastDeclineCurveType(item.ForecastDeclineCurveType);
      this.ForecastDeclineType = new ForecastDeclineType(item.ForecastDeclineType);
      this.ForecastDurationOuomType = new ForecastDurationOuomType(item.ForecastDurationOuomType);
      this.ForecastRatioCurveType = new ForecastRatioCurveType(item.ForecastRatioCurveType);
      this.ForecastRatioFluidType = new ForecastRatioFluidType(item.ForecastRatioFluidType);
      this.ForecastRatioVolumeOuomType = new ForecastRatioVolumeOuomType(item.ForecastRatioVolumeOuomType);
      this.ForecastSegmentType = new ForecastSegmentType(item.ForecastSegmentType);
      this.TypeCurve = new TypeCurve(item.TypeCurve);
      this.ForecastParemeterProductType = new ForecastParemeterProductType(item.ForecastParemeterProductType);
    }
  }
}